import { Accordion, Link, List, Stack, Text } from "basis";
import { useConfigFeature } from "library/hooks/useConfig";
import { Question } from "./Question";

export function Statements({ initiallyOpen }) {
  const showStatementPreferences = useConfigFeature("showStatementPreferences");

  return (
    <Accordion.Item initiallyOpen={initiallyOpen}>
      <Accordion.Item.Header>Statements</Accordion.Item.Header>
      <Accordion.Item.Content>
        <Stack gap="10">
          <Question
            title="Where are my previous credit card statements?"
            productType="credit-card"
          >
            <Text>
              Initially, we are only displaying the most recent statements in
              the new Latitude Service Centre. You can find your previous
              statement history by logging into the Online Service Centre for
              your credit card. Or you can request the statement(s) you need by
              contacting us via{" "}
              <Link href="/contact" newTab={false}>
                Contact Us
              </Link>
              . We'll be happy to help.
            </Text>
          </Question>
          <Question
            title="How do I view my statements online?"
            productType="credit-card"
          >
            <Text>
              Go to View my account for your credit card located on the Overview
              page which will take you to the account details page. To view your
              online statements, simply click on the Statements tab and select
              the statement you'd like to view, save or print. The statement
              will open in a new window (statement date) or download to your
              local device (download button).
              <br />
              <br />
              Note: You can only view statements for credit cards which have
              been linked to your Latitude ID.{" "}
              <Link href="/link-account" newTab={false}>
                Link your account now
              </Link>
            </Text>
          </Question>
          <Question
            title="Where are my Personal Loan statements?"
            productType="personal-loan"
          >
            <Text>
              Personal Loan statements are not currently available in the
              Latitude Service Centre. Please{" "}
              <Link href="/contact" newTab={false}>
                Contact Us
              </Link>{" "}
              to request statement(s).
            </Text>
          </Question>
          <Question
            title="How do I save my statement?"
            productType="credit-card"
          >
            <Text>
              Your online statement will appear as a PDF. To save your
              statement, select the Save a Copy icon at the top of the page and
              choose a location to where you want to save the statement; name
              the file and click on Save.
            </Text>
          </Question>
          <Question
            title="How long is the statement available online?"
            productType="credit-card"
          >
            <Text>
              Your statement is available online for up to{" "}
              <strong>7 years</strong> from the date appearing on your
              statement.
            </Text>
          </Question>
          <Question
            title="Does the Australian Taxation Office accept online statements?"
            productType="credit-card"
            region="AU"
          >
            <Text>
              Yes, online statements are documents recognised by the Australian
              Taxation Office (ATO) and will be treated as paper statements
              would. For specific information relating to your situation, please
              contact the ATO.
            </Text>
          </Question>
          <Question
            title="Why haven't I been sent a statement?"
            productType="credit-card"
          >
            <Text>You may not have received a statement if:</Text>
            <br />
            <List>
              <List.Item>You've chosen to receive online statements</List.Item>
              <List.Item>
                You've updated your address within 7-10 business days before
                your statement is due to be printed
              </List.Item>
              <List.Item>
                The mailing address you've provided is incorrect -{" "}
                <Link href="/contact" newTab={false}>
                  Contact Us
                </Link>{" "}
                to check and update your mailing address
              </List.Item>
              <List.Item>
                The change of address notification you've sent wasn't received -{" "}
                <Link href="/contact" newTab={false}>
                  Contact Us
                </Link>{" "}
                to check and update your mailing address
              </List.Item>
              <List.Item>
                A system error has caused statements to be delayed
              </List.Item>
            </List>
            <br />
            <Text>
              Note: Statements are available for you to view online at any time.
            </Text>
          </Question>
          <Question
            title="What do I need to do to stop receiving paper statements?"
            productType="credit-card"
          >
            {showStatementPreferences ? (
              <Text>
                You can change your statement preferences to online by selecting
                Manage account and then Statement preferences option in the
                Latitude Service Centre.
              </Text>
            ) : (
              <Stack gap="3">
                <Text>
                  We are working on introducing the controls to change your
                  statement delivery preference within the new Latitude Service
                  Centre.
                </Text>
                <Text>
                  In the mean time, you can change your statement preference to
                  online statements by logging into the Online Service Centre
                  for your credit card.
                </Text>
              </Stack>
            )}
          </Question>
        </Stack>
      </Accordion.Item.Content>
    </Accordion.Item>
  );
}
